import type { FaireProductEntity } from "../../entity_types/product";

export const p_ymrcad9679: FaireProductEntity = {
  token: "p_ymrcad9679",
  type: "product",
  name: 'Thank You Letterpress Greeting Card, "the smallest act..."',
  brandToken: "b_bh68gn926z",
  brandName: "Occasionally Speaking",
  imageUrl:
    "https://cdn.faire.com/fastly/576198f6747abe5dba3e0f87e31321401b96ea84186b9049ea310bdd077ec6f9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7591661e788a220c2dc9ef70138967f3e462cac85cfb8305739844901ac3a7df.jpeg",
    "https://cdn.faire.com/fastly/1fa586cc7bde61793fd933201f527e7ef0c5e460775471a6fc4c0f317c1668da.jpeg",
    "https://cdn.faire.com/fastly/2ca40b6ca409402a15b71bdd4c5b6767d64178e9f5e394935fe9307716821e7c.jpeg",
    "https://cdn.faire.com/fastly/328867c57fd2e4347c86120cd9e3af55453d1a9aedb09891d95e394f8184e646.jpeg",
    "https://cdn.faire.com/fastly/12b4c838f03b0e762ceaf43d4c3eb3dafe2d1ac59c8d18d95cdc3151d9154bb8.jpeg",
    "https://cdn.faire.com/fastly/410862f71a2607f73b08fb91a5c7b0d14ea5ea343d0f270203dcfe156fe3f6ee.jpeg",
  ],
  priceDollars: 3.25,
  description:
    'A thank you everyday greeting card letterpress printed on the card front with quote, "the smallest act of kindness is worth more than the grandest intention." Author - Oscar Wilde. Blank inside.\n\nMerchandising tip: This expression of gratitude from the heart can be assorted with other Thank You cards year round.\n\n- 100% cotton paper card and envelope from the oldest mill in the world, Fabriano, in Italy\n\n- Handmade deckle edge paper detail\n\n- Letterpress printed using an artisan technique\n\n- Soy-based inks in deep blue and gold are friendlier to the environment\n\n- Elegant 3.5" x 5.25" card size with envelope to match in protective plastic sleeve\n\n- Printed and hand assembled in the USA\n\n- Sold in retail unit of 6 cards',
  tags: [],
  msrpDollars: 6.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:05.034Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
